module.exports = __webpack_public_path__ + "static/media/p14.59f65aa5.jpeg";